define([
    './module',

    './scripts/toolbar.directive',
    './scripts/toolbarOptions.provider'
], function(module_name) {
    return module_name;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-toolbar/main.js
// module id = 11
// module chunks = 0